import type { PlayerMatchmakerState } from '@/api/public'

export type PlayerPartyRosterLockReason =
  | 'ready_check'
  | 'runtime_roster_pending'

export type PlayerPartyRosterLockCapability = {
  locked: boolean
  reason: PlayerPartyRosterLockReason | null
  compatibilityFallback: boolean
}

type PlayerPartyRosterLockState = Pick<
  PlayerMatchmakerState,
  'status' | 'party_roster_locked' | 'party_roster_lock_reason'
>

export function resolvePlayerPartyRosterLock(
  state: PlayerPartyRosterLockState | null,
): PlayerPartyRosterLockCapability {
  if (typeof state?.party_roster_locked === 'boolean') {
    return {
      locked: state.party_roster_locked,
      reason: state.party_roster_locked
        ? state.party_roster_lock_reason ?? inferredLockReason(state.status)
        : null,
      compatibilityFallback: false,
    }
  }

  const locked = state?.status === 'ready_check' || state?.status === 'in_match'
  return {
    locked,
    reason: locked ? inferredLockReason(state?.status ?? 'idle') : null,
    compatibilityFallback: locked,
  }
}

export function playerPartyRosterLockMessage(
  reason: PlayerPartyRosterLockReason | null,
): string {
  switch (reason) {
    case 'ready_check':
      return 'Состав заблокирован во время подтверждения игры.'
    case 'runtime_roster_pending':
      return 'Состав заблокирован до создания игрового лобби.'
    default:
      return 'Состав группы временно заблокирован.'
  }
}

function inferredLockReason(
  status: PlayerMatchmakerState['status'],
): PlayerPartyRosterLockReason | null {
  if (status === 'ready_check') return 'ready_check'
  if (status === 'in_match') return 'runtime_roster_pending'
  return null
}
